// ----------------------------------------------------------------------
// <copyright file="Izenda.UserMenu.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var actions = require('share/components/layout/Izenda.UserMenuActions');
  var uiState = require('logic/Izenda.UiState');
  var routeUtils = require('share/utils/Izenda.RouteUtils');
  var Config = require('Izenda.Config');

  var NotificationBoard = require('share/components/controls/Izenda.NotificationBoard');
  var HelpSystem = require('share/components/controls/Izenda.HelpSystem');

  const { truncate } = require('lodash/fp');
  var UserMenu = function(props) {
    var localization = props.localization;
    var router = props.router;

    var renderMyProfileLink = function() {
      var myProfileUrl = routeUtils.getMyProfileUrl();

      var goToProfile = function goToProfile() {
        props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(function() {
          router.push(myProfileUrl);
        });
      };

      return (
        <li>
          <a onClick={goToProfile}>{localization.getText('USER_MENU_MY_PROFILE')}</a>
        </li>
      );
    };
    var fullName = truncate({ length: 30 }, uiState.currentUser.fullName);
    return (
      <div className="izenda-UserMenu u-posAbsolute">
        <div className="btn-group izenda-UserMenu-Info" role="group">
          <a
            className="btn dropdown-toggle"
            ref={function(dom) {
              dom && $izenda(dom).dropdown();
            }}
            aria-haspopup
            aria-expanded="false"
            data-toggle="dropdown"
            title={uiState.currentUser.fullName}
          >
            {fullName} &nbsp;
            <span className="caret" />
          </a>
          <ul className="dropdown-menu">
            {!uiState.expiredLicense && renderMyProfileLink()}
            {!Config.Integration && (
              <li>
                <a onClick={props.onClickSignOut}>{localization.getText('USER_MENU_SIGN_OUT')}</a>
              </li>
            )}
          </ul>
        </div>
        <div className="izenda-UserMenu-Bell u_fullInlineBlock">
          <NotificationBoard notificationMessages={uiState.notificationMessages} />
        </div>
        <HelpSystem />
      </div>
    );
  };

  module.exports = connect(actions)(UserMenu);
})();



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.UserMenu.jsx